import React, { useState } from 'react'
import stylesheetHeader from "./cart.module.css"
import ButtonInit from "../../component/button/index"
import Product_image2 from "../../../assets/images/CBD2.webp"


const Cart = () => {
    const [cartcount,setcartcount] =useState(0)

    return (
        <>
        <div className={`col-12 ${stylesheetHeader.main_cart} p-0`}>
                    <div className={stylesheetHeader.cart_Session}>
                        <div className={stylesheetHeader.cart_data}>
                            <div className={stylesheetHeader.cart_data_left}>
                                <div className={stylesheetHeader.cartImage}>
                                    <img src={Product_image2} alt="" />
                                </div>
                                <div className={stylesheetHeader.carttitle}>
                                    <h6>Created . Pre-Rolled</h6>
                                    <button>Delete</button>
                                </div>
                            </div>
                            <div className={stylesheetHeader.cart_data_right}>
                                <div className={stylesheetHeader.cartprice}>
                                    <h6>$40.8</h6>
                                </div>
                                <div className={stylesheetHeader.cart_calc}>
                                    <button onClick={()=>{setcartcount(prevActiveStep => prevActiveStep + 1)}}>+</button><div className={stylesheetHeader.calc_display}>{cartcount}</div><button onClick={()=>{setcartcount(prevActiveStep => prevActiveStep - 1)}}>-</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={stylesheetHeader.cart_function_Session}>
                        <div className="d-flex align-items-center justify-content-between">
                            <h5>Subtotal</h5>
                            <h5>$90.66</h5>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <h5>Shipping</h5>
                            <h5>$90.66</h5>
                        </div>


                        <div className="d-flex align-items-center justify-content-between">
                            <h5>Total</h5>
                            <h5>$90.66</h5>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className='p-1 w-100'>
                            <ButtonInit width={"100"} value={"Edit"}/>
                            </div>
                            <div className='p-1 w-100'>
                            <ButtonInit width={"100"} value={"Checkout"}/>
                            </div>

                        </div>
                    </div>
        </div>
        </>
    )
}



export default React.memo(Cart)
